"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=quote.js.map